<template>
  <div>
    <!-- <sidenav
      :is-sidebar-active.sync="isSidebarActive"
      :item-edit.sync="itemEdit"
      :is-add.sync="isAdd"
      @refetch-data="refetchData"
      :permissions-options="permissionsOptions"
      :tenant-options="tenantOptions"
      :type-alarm-options="alarmTypeOptions"
      :user-options="userOptions"
    /> -->

    <b-row class="pt-2 pb-1">
      <b-col cols="6" class="d-flex align-items-center">
        <BreadcrumbMenu />
      </b-col>
      <b-col cols="6" class="pr-3 text-right">
        <button-filters
          @show-modal="$root.$emit('bv::show::modal', $event)"
          :filters-count="filtersCount"
          @clear-search-filters="clearSearchFilters"
        />
      </b-col>
    </b-row>

    <!-- Filters -->
    <filter-modal
      @action="buildFilters()"
      @clear="clearSearchFilters()"
    >
      <template v-slot:main-filters>
        <filters
          :permissions-filter.sync="permissionsFilter"
          :permissions-options="permissionsOptions"
          :tenant-filter.sync="tenantFilter"
          :tenant-options="tenantOptions"
          :alarm-type-filter.sync="alarmTypeFilter"
          :alarm-type-options="alarmTypeOptions"
          :user-filter.sync="userFilter"
          :user-options="userOptions"
        />
      </template>
    </filter-modal>

    <!-- Wizard -->
    <wizard
      :is-wizard-active.sync="isWizardActive"
      :item-edit.sync="itemEdit"
      :is-add.sync="isAdd"
      @close-wizard="closeWizard"
      @refetch-data="refetchData"
      @isAdd-false="isAdd = false"
      :user-options="userOptions"
      :type-alarm-options="alarmTypeOptions"
      :tenant-options="tenantOptions"
      :profile-options="profileOptions"
    />

    <!-- Table Container Card -->
    <b-card class="m-2" no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="text-capitalize">{{ $t("table.show") }}</label>
            <v-select
              data-cy="automatest-v-select-pagination-control"
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label class="text-capitalize">{{ $t("table.entries") }}</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                data-cy="search-input"
                v-model="searchQuery"
                class="d-inline-block mr-1"
                :placeholder="$t('table.search')"
              />
              <b-button variant="primary" data-cy="automatest-add-group-btn" @click="openWizard()">
                <span class="text-nowrap text-capitalize">
                  {{ $t("group.add_group") }}
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refListTable"
        class="position-relative"
        :items="fetchList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('no_record_found')"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #head()="data">
          <span> {{ $tc(data.label, 1) }}</span>
        </template>

        <template #head(type)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(permissions_count)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(actions)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #cell(frame_color)="data">
          <div
            :style="`background: ${data.item.frame_color};
                        width: 2rem;
                        height: 2rem;
                        border-radius: 1rem;
                        text-align: center;`"
          ></div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-button
            :id="`actions-${data.item.id}`"
            tabindex="0"
            variant="white"
            class="px-1 btn-y"
          >
            <feather-icon
              data-cy="actions"
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </b-button>
          <b-popover
            :target="`actions-${data.item.id}`"
            triggers="focus"
            placement="bottom"
            custom-class="popover-p-0"
            variant="white"
          >
            <b-list-group class="m-0">
              <b-list-group-item
                v-if="$can('update', 'Group')"
                class="border-0"
                button
                @click="editGroupSharedTenant(data.item.id, data.item.name)"
              >
                <feather-icon icon="VideoIcon" />
                <span class="align-middle ml-50 text-capitalize">
                  {{ $t("users.shared_tenants") }}
                </span>
              </b-list-group-item>

              <b-list-group-item
                data-cy="automatest-edit-group-btn"
                v-if="$can('update', 'Group')"
                class="border-0"
                button
                @click="openEdit(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50 text-capitalize">
                  {{ $t("actions.edit") }}
                </span>
              </b-list-group-item>

              <b-list-group-item
                data-cy="automatest-delete-group-btn"
                v-if="$can('delete', 'Group')"
                class="border-0"
                button
                @click="confirmDelete(data.item.id)"
              >
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50 text-capitalize">
                  {{ $t("actions.delete") }}
                </span>
              </b-list-group-item>
            </b-list-group>
          </b-popover>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted text-capitalize">{{
              $t("table.showing", {
                from: dataMeta.from,
                to: dataMeta.to,
                of: dataMeta.of,
              })
            }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            data-cy="pagination"
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <Pagination
              :totalList="totalList"
              :currentPage="currentPage"
              @updatePagination="update"
              :perPage="perPage"
            >
            </Pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
  BPopover,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, watch } from "@vue/composition-api";
import useList from "./useList";
import Sidenav from "./Sidenav.vue";
import Wizard from "./wizard/Wizard.vue";
import Filters from "./Filters.vue";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import router from "@/router";
import Pagination from "@/components/Pagination.vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import FilterModal from "@/components/Filters/FilterModal.vue";
import ButtonFilters from "@/components/Filters/ButtonFilters.vue";

export default {
  components: {
    Wizard,
    Sidenav,
    Filters,
    Pagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    router,
    BreadcrumbMenu,
    BPopover,
    FilterModal,
    ButtonFilters,
  },
  setup(_, context) {
    //start pagination
    const update = (data) => {
      currentPage.value = data;
    };
    //end pagination

    const isSidebarActive = ref(false);
    const itemEdit = ref({});
    const isAdd = ref(false);
    const isWizardActive = ref(false);

    const openEdit = (item) => {
      store
        .dispatch("group/show", item.id)
        .then((response) => {
          const group = response.data != null ? response.data : response;
          itemEdit.value = group;
          isAdd.value = false;
          isWizardActive.value = true;
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Error obteniendo el grupo",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };
    const { t } = useI18nUtils();

    const toast = useToast();

    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      tenantOptions,
      tenantFilter,
      permissionsOptions,
      permissionsFilter,
      alarmTypeOptions,
      alarmTypeFilter,
      userOptions,
      userFilter,
      buildFilters,
      clearSearchFilters,
      filtersCount,
      profileOptions,
    } = useList();

    function getQueryParam(param) {
      const queryString = window.location.hash.split('?')[1]; // Extract the query string after `#`
      if (!queryString) return null;

      const params = new URLSearchParams(queryString);
      return params.get(param);
    }

    // Get "groupId" from URL
    const groupId = getQueryParam('groupId');

    const openEditFromUser = (groupId)=>{
      const dataGroup = ref({});
      const storeInner = store;
      if (groupId) {
          storeInner
            .dispatch("group/show", groupId)
            .then((response) => {
              if (response.success) {
                toast({
                  component: ToastificationContent,
                  props: {
                    title: response.message,
                    icon: "CheckIcon",
                    variant: "success",
                  },
                });
                console.log(response.data);
                openEdit(response.data);
              } else {
                toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: response.message,
                      icon: "AlertTriangleIcon",
                      variant: "danger",
                    },
                  },
                  {
                    timeout: 10000,
                  }
                );
              }
            })
            .catch((response) => {
              toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: response.response.data.message,
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                },
                {
                  timeout: 10000,
                }
              );
            });
        }
    }
    openEditFromUser(groupId);
    const editGroupCameras = function (id, name) {
      router.push({
        name: "group_cameras",
        params: { id_group: id, name: name },
      });
    };

    const editGroupSharedTenant = function (id, group) {
      router.push({
        name: "group_shared_tenant",
        params: { id_group: id, group: group },
      });
    };

    const confirmDelete = function (id) {
      const self = this;
      const storeInner = store;
      this.$swal({
        title: context.parent.$i18n.t("messages.delete.title"),
        text: context.parent.$i18n.t("messages.delete.body"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: context.parent.$i18n.t("actions.delete"),
        cancelButtonText: context.parent.$i18n.t("actions.cancel"),
        customClass: {
          confirmButton: "btn btn-primary text-capitalize",
          cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          storeInner
            .dispatch("group/delete", id)
            .then((response) => {
              if (response.success) {
                toast({
                  component: ToastificationContent,
                  props: {
                    title: response.message,
                    icon: "CheckIcon",
                    variant: "success",
                  },
                });
                self.refetchData();
              } else {
                toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: response.message,
                      icon: "AlertTriangleIcon",
                      variant: "danger",
                    },
                  },
                  {
                    timeout: 10000,
                  }
                );
              }
            })
            .catch((response) => {
              toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: response.response.data.message,
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                },
                {
                  timeout: 10000,
                }
              );
            });
        }
      });
    };

    const openAdd = () => {
      isAdd.value = true;
      isSidebarActive.value = true;
    };

    const openWizard = () => {
      isAdd.value = true;
      isWizardActive.value = true;
    };

    const closeWizard = function () {
      isWizardActive.value = false;
      //store.dispatch("camera_proxy/clearAll");
    };

    return {
      update,
      isSidebarActive,
      isAdd,
      itemEdit,
      openEdit,
      openAdd,
      confirmDelete,
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      tenantOptions,
      tenantFilter,
      permissionsOptions,
      permissionsFilter,
      alarmTypeOptions,
      alarmTypeFilter,
      profileOptions,
      userOptions,
      userFilter,
      editGroupCameras,
      editGroupSharedTenant,
      buildFilters,
      clearSearchFilters,
      filtersCount,
      isWizardActive,
      openWizard,
      closeWizard,
    };
  },
};
</script>
